import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { AppShell } from "@/components/AppShell";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Home from "@/pages/Home";
import Matches from "@/pages/Matches";
import MatchDetail, { HistoryList } from "@/pages/MatchDetail";
import Stats from "@/pages/Stats";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";
import Claim from "@/pages/Claim";

const Splash = () => (
  <div className="min-h-[100dvh] flex flex-col items-center justify-center" data-testid="splash">
    <img src="/icon-192.png" alt="Gogoats" className="w-24 h-24 rounded-3xl animate-pulse" />
    <p className="font-display font-black text-2xl mt-4text-slate-900">GO<span className="text-cyan-500">GOATS</span></p>
  </div>
);

const Protected = ({ children, admin }) => {
  const { user } = useAuth();
  if (user === null) return <Splash />;
  if (!user) return <Navigate to="/connexion" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
};

const PublicOnly = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <Splash />;
  return user ? <Navigate to="/" replace /> : children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/connexion" element={<PublicOnly><Login /></PublicOnly>} />
          <Route path="/inscription" element={<PublicOnly><Register /></PublicOnly>} />
          <Route path="/reclamer" element={<PublicOnly><Claim mode="claim" /></PublicOnly>} />
          <Route path="/mot-de-passe-oublie" element={<PublicOnly><Claim key="reset" mode="reset" /></PublicOnly>} />
          <Route element={<Protected><AppShell /></Protected>}>
            <Route index element={<Home />} />
            <Route path="matchs" element={<Matches />} />
            <Route path="matchs/historique" element={<HistoryList />} />
            <Route path="matchs/:id" element={<MatchDetail />} />
            <Route path="statistiques" element={<Stats />} />
            <Route path="profil" element={<Profile />} />
            <Route path="joueur/:id" element={<Profile />} />
            <Route path="admin" element={<Protected admin><Admin /></Protected>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="light" position="top-center" richColors toastOptions={{ style: { borderRadius: 16 } }} />
    </AuthProvider>
  );
}

export default App;
